<template>
  <div class='user-details'>
     <h1>User Details</h1>
     <span style="float: right">
        <el-input
            placeholder="Search"
            v-model="search"
            >
         </el-input>
     </span>
     <el-table :data="users" style="margin-top: 4em; width: 100%">
         <el-table-column
            v-for="(column, index) in tableColumns"
            :key="index"
            :label="column.label"
            :width="column.width"
            :prop="column.prop"
            :formatter="column.formatter"
         />
         <el-table-column
            fixed="right"
            label="Operations"
            width="120">
            <template slot-scope="scope">
               <el-button @click="editUser(scope.row);" type="text" size="small">Edit</el-button>
               <el-button @click="deleteUser(scope.row);" type="text" size="small">Delete</el-button>
            </template>
         </el-table-column>
      </el-table>
      <el-pagination
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         :current-page.sync="currentPage"
         :page-sizes="[10, 20, 50, 100]"
         :page-size="20"
         layout="sizes, prev, pager, next"
         :total="users.length">
      </el-pagination>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, Input } from 'element-ui';
import { fetchWithAuthToken } from '@/axios';
import { confirm, showError, showSuccess } from '../../../../../js/ui-helpers';
import { postWithAuthToken } from '../../../../../axios';

export default {
   name: 'user-list',
   components: {
      'el-table': Table,
      'el-table-column': TableColumn,
      'el-input': Input,
      'el-button': Button,
      'el-pagination': Pagination,
   },
   data() {
      return {
         tableColumns: [
            {label: 'Email',     prop: 'email',     width: 230},
            {label: 'Name',      prop: 'full_name', },
            {label: 'Active',    prop: 'is_active', width: 100, formatter: active => active ? 'Yes': 'No'},
            {label: 'Phone No.', prop: 'phone_no', width: 110},
            {label: 'Role',     prop: 'role', width: 150},
         ],
         users: [],
         currentPage: 1,
         search: '',
      }
   },
   watch: {
      search: {
         immediate: true,
         handler: 'loadUsers',
      }
   },
   methods: { 
      editUser(user)
      {
         this.$router.push({name: 'edit-user', params: {user_id: user.id}});
      },
      deleteUser(user)
      {
         confirm({
            title: `Delete User (${user.first_name} - ${user.email})?`,
            msg: "Are you sure you want to delete this user?",
            onSuccess: () => {
               postWithAuthToken(`/api/users/${user.id}`, {}, {
                  method: 'DELETE'
               })
               .then(() =>
               {
                  showSuccess('Delete User', 'Successfully deleted user!');
                  this.loadUsers();
               })
               .catch(() =>
               {
                  showError('Delete User', "Couldn't delete user");
               })
            }
         });
      },
      loadUsers()
      {
         fetchWithAuthToken(`api/users/?managed_users=true&search=${this.search}`)
         .then(({data}) => {
            this.users=data;
            console.log(data)
         })
      },
      handleSizeChange(val)
      {
         console.log(`${val} items per page`)
      },
      handleCurrentChange(val)
      {
         console.log(`${val} current page`)
      },
   }
}
</script>

<style lang="scss" scoped>
.user-details {
   padding: 1em;
}
</style>
